import styled from 'styled-components';

export const NotificationsForm = styled.form`
	display: flex;
	flex-direction: column;
	padding: 5px 15px 15px;
`;
